import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import OpsAssetsPage from './operations/OpsAssetsPage';
import OpsCatalogPage from './operations/OpsCatalogPage';
import OpsCommitmentsPage from './operations/OpsCommitmentsPage';
import OpsProcessPage from './operations/OpsProcessPage';
import OpsUpdatesPage from './operations/OpsUpdatesPage';
import OpsWaiverPage from './operations/OpsWaiverPage';

/**
 * The Operations suite, ported from the coworker dashboard's /operations nav.
 *
 * Each view has its own URL, so selecting one is a real navigation: deep links,
 * reloads, the back button and shared links all behave the same way.
 *
 * Assets and Creative read the Box crawl snapshot out of Postgres, so they need
 * no Box credential; only the live refresh crawl / release mail / live folder
 * listing would, and those are not ported. Waiver composes its letter
 * client-side and falls back to mailto: until WAIVER_MSAL_CLIENT_ID is set.
 * Whole tab is gated on the `operations` perm in App.js.
 */
const VIEWS = [
  {
    id: 'assets',
    label: 'Assets',
    path: '/operations/assets',
    Component: () => <OpsAssetsPage view="assets" />,
  },
  {
    id: 'creative',
    label: 'Creative',
    path: '/operations/creative',
    Component: () => <OpsAssetsPage view="creative" />,
  },
  { id: 'catalog', label: 'Catalog', path: '/operations/catalog', Component: OpsCatalogPage },
  {
    id: 'commitments',
    label: 'Commitments',
    path: '/operations/commitments',
    Component: OpsCommitmentsPage,
  },
  { id: 'process', label: 'Process', path: '/operations/process', Component: OpsProcessPage },
  { id: 'waiver', label: 'Waiver', path: '/operations/waiver', Component: OpsWaiverPage },
  { id: 'updates', label: 'Updates', path: '/operations/updates', Component: OpsUpdatesPage },
];

export default function OperationsPage() {
  const navigate = useNavigate();
  const location = useLocation();

  // The path is the source of truth: /operations bare redirects to /catalog.
  const byPath = VIEWS.find((v) => location.pathname.startsWith(v.path));
  const active = byPath?.id || VIEWS[0].id;

  const setActive = (next) => {
    const view = VIEWS.find((v) => v.id === next);
    if (view && view.path !== location.pathname) navigate(view.path);
  };

  const Active = (VIEWS.find((v) => v.id === active) || VIEWS[0]).Component;

  return (
    <div>
      <div className="mb-3 flex flex-wrap items-center gap-1.5">
        {VIEWS.map((view) => (
          <button
            key={view.id}
            type="button"
            onClick={() => setActive(view.id)}
            className={`rounded-full px-3 py-1.5 text-sm font-medium transition-colors ${
              active === view.id
                ? 'bg-teal-600 text-white'
                : 'bg-white text-gray-700 border border-gray-200 hover:bg-gray-50'
            }`}
          >
            {view.label}
          </button>
        ))}
      </div>
      <Active />
    </div>
  );
}
